import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

console.log('v1.0.0');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
